<template>
  <div>
    <div class="flex-1 relative pb-8 z-0">
      <div class="bg-white shadow">
        <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="pt-6 pb-6 md:flex md:items-center justify-between lg:border-t lg:border-cool-gray-200">
            <div class="text-3xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
              Settings
            </div>

            <div />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Settings',

  components: {

  },

  data() {
    return {

    };
  },

  computed: {

  },

  watch: {

  },

  mounted() {

  },

  methods: {

  },

};
</script>
